export default __webpack_public_path__ + "static/media/drawer.22c98cb7.png";